import AuthService from '@/core/auth/AuthService'

export default {
    install(Vue) {
        Vue.prototype.$keycloak = AuthService
    },
}
